import React from 'react';

type Params = {
  email?: string;
  fullName: string;
  title: string;
};
const coworkerResultComponent = ({ email, fullName, title }: Params) => {
  if (email) return <span>{`${fullName} (${email})`}</span>;
  if (title) return <span>{`${fullName} (${title})`}</span>;
  return <span>{fullName}</span>;
};

export default coworkerResultComponent;
